// @core/api/endpoints/localization/update_locale.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LocaleResponse,
  UpdateLocaleRequest,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Update locale
 * Updates locale properties such as name, formats, and status.
 */
export async function UpdateLocale(
  locale_id: string,
  data: UpdateLocaleRequest,
  options?: RequestOptions
): Promise<LocaleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/locales/:locale_id`;
  requestPath = requestPath.replace(':locale_id', encodeURIComponent(locale_id));
  const requestOptions = options;
  return client.put<LocaleResponse>(requestPath, data, requestOptions);
}
